export * from "./room-content-item";
export * from "./room-content-presenter";
export * from "./room-content-breadcrumb-presenter";

import { RoomContentBreadcrumbPresenterComponent } from "./room-content-breadcrumb-presenter";
import { RoomContentItemComponent } from "./room-content-item";
import { RoomContentPresenterComponent } from "./room-content-presenter";



export const RoomContentAtoms = [
    RoomContentItemComponent,
    RoomContentPresenterComponent,
    RoomContentBreadcrumbPresenterComponent
]